import { mergeClasses } from "../lib/mergeClasses";

type SpinnerProps = {
  className?: string;
}
function Spinner({ className = "" }: SpinnerProps) {
  return (
    <div className={mergeClasses("animate-spin w-3 h-3 border-white border-2 border-t-transparent rounded-full", className)}></div>
  )
}

export default Spinner
